export default "__VITE_PUBLIC_ASSET__209a40af__"